
import Vue from "vue";
import IconOverContent from "@/components/common/IconOverContent.vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "tran-service-over-content",
  components: { IconOverContent },
  mixins: [UIFeatureMixin],
});
